import Button from 'components/Button'
import Dialog from 'components/Dialog'
import React, { useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { toast } from 'react-toastify'

import { request } from '../../../../1stlog-ui/src/utils'

const Delete = (props) => {
  const { setLoading, applyFilter, name, id } = props

  const [openDialog, setDialog] = useState(false)

  const onSubmit = async () => {
    setDialog(false)
    try {
      setLoading(true)
      const { data } = await request({
        method: 'delete',
        url: `/api/cronorder/${id}`,
      })

      toast.success(
        i18n.t('success_delete_cron_order', 'Dauerauftrag gelöscht'),
      )
    } catch (err) {
      toast.error(
        i18n.t(
          'error_delete_cronorder',
          'Dauerauftrag konnte nicht gelöscht werden',
        ),
      )
      console.error(err)
    } finally {
      setLoading(false)

      applyFilter({ reset: true, onlyFts: false })
    }
  }

  const handleClose = () => setDialog(false)

  return (
    <>
      <Button
        danger
        icon="fas fa-trash"
        onClick={() => setDialog(true)}
        sm
        className="mr-2"
        tooltip={i18n.t('recall_box', 'Dauerauftrag löschen')}
      ></Button>
      <Dialog
        show={openDialog}
        onHide={(e) => handleClose(e)}
        size="md"
        title={i18n.t(`delete_propmpt_cron_order`, {
          defaultValue: `Dauerauftrag "{{placeholder1}}" wirklich löschen?`,
          placeholder1: name,
        })}
      >
        <Container>
          <Row>
            <Col md={12} className="d-flex justify-content-between">
              <Button onClick={(e) => handleClose(e)}>
                <b>{i18n.t('btn_cancel', 'Abbrechen')}</b>
              </Button>

              <Button variant="success" onClick={onSubmit}>
                <b>{i18n.t('btn_delete', 'Löschen')}</b>
              </Button>
            </Col>
          </Row>
        </Container>
      </Dialog>
    </>
  )
}

export default Delete
